module.exports = __webpack_public_path__ + "static/img/gif11.145d7403.jpg";